const font = {
  weight: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 600,
  },
};

export default font;
